import React from 'react';
import { ToastOptions, toast } from 'react-toastify';
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from '@buyside/components/presentation/Button/button';

import isLocalStorageNameSupported from '@buyside/util/isLocalStorageNameSupported';

import styles from '@buyside/components/presentation/Toasters/toasterStyles.scss';

export const persistentToast = (
  content: string | React.ReactElement,
  options: ToastOptions & { toastId: string; disableIndefiniteDismiss?: boolean }
): void => {
  const isLocalStorageSupported = isLocalStorageNameSupported();
  if (!isLocalStorageSupported) return;

  const currentDay = new Date().getDate();
  const { disableIndefiniteDismiss, toastId } = options;

  const isHidden = window.localStorage.getItem(`${toastId}-dateClosed`) === String(currentDay);
  const isHiddenIndefinitely = window.localStorage.getItem(`${toastId}-closed`) === 'true';

  if (isHidden || isHiddenIndefinitely) return;

  const onClose = (indefinite: boolean): void => {
    if (indefinite) {
      window.localStorage.setItem(`${toastId}-closed`, 'true');
    } else {
      window.localStorage.setItem(`${toastId}-dateClosed`, String(currentDay));
    }

    toast.dismiss(toastId);
  };

  toast(
    <div>
      {content}
      <div className={styles.dismissActions}>
        <Button
          faIcon={faXmark}
          onClick={(): void => onClose(false)}
          size={BUTTON_SIZES.SMALL}
          text="Dismiss"
          type={BUTTON_TYPES.LINK}
        />
        {disableIndefiniteDismiss ? null : (
          <Button
            onClick={(): void => onClose(true)}
            size={BUTTON_SIZES.SMALL}
            text="Don't Show Again"
            type={BUTTON_TYPES.LINK}
          />
        )}
      </div>
    </div>,
    {
      closeButton: false,
      theme: 'dark',
      ...options
    }
  );
};
